import dayjs from 'dayjs';
import { IMerchant } from 'app/shared/model/merchant.model';
import { ICustomer } from 'app/shared/model/customer.model';
import { UserCashBackStatus } from 'app/shared/model/enumerations/user-cash-back-status.model';

export interface IUserCashBack {
  id?: string;
  totalCashBack?: number | null;
  filePath?: string | null;
  remark?: string | null;
  receiptId?: string | null;
  receiptAmount?: number | null;
  receiptDate?: dayjs.Dayjs | null;
  errorMessage?: string | null;
  createdAt?: dayjs.Dayjs | null;
  status?: keyof typeof UserCashBackStatus | null;
  merchant?: IMerchant | null;
  customer?: ICustomer | null;
}

export const defaultValue: Readonly<IUserCashBack> = {};
